export default __webpack_public_path__ + "static/media/tech-in-asia.d18fb929.svg";